import * as Yup from 'yup';
import { ProviderCommissionType } from '@prisma/client';
import { CheckoutFormValues } from '../../types/appointments';
import { testPhoneNumbervalue } from '../global/helper';
import { getEmailSchema } from '../../types/global';

export const initFormValues: CheckoutFormValues = {
  customer: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    customerId: '',
    dob: '',
  },
  employeeId: '',
  appointmentId: '',
  startDateTime: '',
  price: 0,
  tipAmt: 0,
  tipPercentage: null,
  paymentMethod: '' as any,
  customOrderItems: [],
  additionalServices: [],
  providerCommissionType: ProviderCommissionType.BASE,
  isCashTaxed: true,
  giftCardType: 'internal',
};

export const getCustomerCheckoutSchema = ({
  isGuestCheckout = false,
}: { isGuestCheckout?: boolean } = {}) =>
  Yup.object({
    firstName: isGuestCheckout
      ? Yup.string().nullable().optional()
      : Yup.string().required('First name is required'),
    lastName: Yup.string().nullable().optional(),
    email: getEmailSchema('Invalid email', false).nullable().optional(),
    phoneNumber: isGuestCheckout
      ? Yup.string()
          .nullable()
          .optional()
          .test({
            test: value => !value || testPhoneNumbervalue(value),
            message: 'Invalid phone number',
          })
      : Yup.string()
          .test({
            test: testPhoneNumbervalue,
            message: 'Invalid phone number',
          })
          .required('Phone number is required'),
    dob: Yup.string().nullable().optional(),
    customerId: Yup.string().nullable().optional(),
  });

export const getCheckoutSchema = ({
  isGuestCheckout = false,
}: { isGuestCheckout?: boolean } = {}) =>
  Yup.object().shape({
    customer: getCustomerCheckoutSchema({ isGuestCheckout }).required(),
    employeeId: Yup.string(),
    appointmentId: Yup.string(),
    price: Yup.number(),
    tipAmt: Yup.number(),
    paymentMethod: Yup.string().optional(),
    giftCardAmount: Yup.number().optional(),
  });
